import { css } from "styled-components"

export const TABLE_STYLE = css`
  // Spacious layout
  @container (max-width: 1200px) {
    col[data-column-name="referenceNumber"] {
      width: 0 !important;
      min-width: 0 !important;
    }
  }

  // Wide Layout
  @container (max-width: 1000px) {
    col[data-column-name="party"][width="99%"] ~ col[data-column-name="displayCategory"] {
      width: 0 !important;
      min-width: 0 !important;
    }
    // show the displayCategory when the source is the interesting side (Party pages)
    .interesting-source & {
      col[data-column-name="party"][width="99%"] ~ col[data-column-name="relatedCategory"] {
        width: 0 !important;
        min-width: 0 !important;
      }
      col[data-column-name="party"][width="99%"] ~ col[data-column-name="displayCategory"] {
        width: 99% !important;
        min-width: unset !important;
      }
    }
  }

  // Standard Layout
  @container (max-width: 800px) {
    col[data-column-name="relatedCategory"] {
      width: 200px !important;
    }
    col[data-column-name="displayCategory"] {
      width: 0 !important;
      min-width: 0 !important;
    }

    // show the displayCategory when the source is the interesting side (Party pages)
    .interesting-source & {
      col[data-column-name="relatedCategory"] {
        width: 0 !important;
        min-width: 0 !important;
      }
      col[data-column-name="displayCategory"] {
        width: 200px !important;
      }
    }
  }

  // Mobile layout
  @container (max-width: 600px) {
    col[data-column-name="timestamp"] {
      width: 70px !important;
    }

    col[data-column-name="source"],
    col[data-column-name="relatedCategory"],
    col[data-column-name="displayCategory"],
    col[data-column-name="referenceNumber"] {
      width: 0 !important;
      min-width: 0 !important;
    }
  }

  // Edits
  col[data-column-name="checkbox"] {
    transition: width 200ms ease-out;
  }

  th[data-header="checkbox"],
  td[data-column="checkbox"] {
    transform: translate3d(0, 0, 0);
    will-change: width;
    text-overflow: unset;
    padding-top: 0;
    padding-bottom: 0;
    padding-right: 16px;
  }
  th[data-header="checkbox"] + th[data-header="timestamp"],
  td[data-column="checkbox"] + td[data-column="timestamp"] {
    padding-left: 16px;
  }

  th[data-header="source"],
  td[data-column="source"] {
    text-align: center;
  }

  th[data-header="relatedCategory"],
  th[data-header="displayCategory"] {
    padding-left: 16px;
  }

  .transaction-updated {
    background-color: #7597e84d;
  }
`
